import styled from 'styled-components';
import { COLORS, SIZE } from '@app/src/ui';
import ReCAPTCHA from 'react-google-recaptcha';

export const List = styled.ul`
  border: 1px solid ${COLORS.GRAY};
  margin: 0 -15px;
  min-height: 65px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 15px auto 0;
    width: 100%;
  }
`;

export const RecaptchaWrapper = styled.div`
  max-width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  opacity: .5;
`;

export const Recaptcha = styled(ReCAPTCHA)`
  transform-origin: 0 0;
  transform: scale(0.8) translateX(10%);
`;

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;